import PropTypes from 'prop-types';
import { discountType } from './discount-types';

export const autopayAccountType = PropTypes.shape({
  accountNumber: PropTypes.string,
  accountType: PropTypes.string,
  accountTypeDescription: PropTypes.string,
  achAccountId: PropTypes.string,
  ownerName: PropTypes.string,
  routingNumber: PropTypes.string,
});

export const crossSellAppStatusType = PropTypes.shape({
  crossSellAppUuid: PropTypes.string,
  crossSellStatus: PropTypes.string,
});

export const consentType = PropTypes.shape({
  type: PropTypes.string,
  uuid: PropTypes.string,
  version: PropTypes.number,
});

export const disburseAccountType = PropTypes.shape({
  accountNumber: PropTypes.string,
  accountType: PropTypes.string,
  accountTypeDescription: PropTypes.string,
  achAccountId: PropTypes.string,
  ownerName: PropTypes.string,
  routingNumber: PropTypes.string,
});

export const documentType = PropTypes.shape({
  countryCode: PropTypes.string,
  createdDate: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  uuid: PropTypes.string,
});

export const incomeType = PropTypes.shape({
  incomePrimary: PropTypes.number,
  incomeCoSigner: PropTypes.number,
  incomeOther: PropTypes.number,
});

export const employerAddressType = PropTypes.shape({
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
});

export const incomeSourceType = PropTypes.shape({
  employer: PropTypes.string,
  employerAddress: employerAddressType,
  employmentType: PropTypes.string,
  uuid: PropTypes.string,
});

export const manualPaystub = PropTypes.shape({
  complete: PropTypes.bool,
});

export const selectedOfferType = PropTypes.shape({
  amount: PropTypes.number,
  aprRate: PropTypes.number,
  rate: PropTypes.number,
  term: PropTypes.number,
  type: PropTypes.string,
  originationFeePercentage: PropTypes.number,
  selectedDiscounts: PropTypes.arrayOf(discountType),
});

export const giactAccountStatusType = PropTypes.oneOf(['INITIAL', 'PENDING_REVIEW', 'VERIFIED']);

export const statusType = PropTypes.shape({
  applicationUuid: PropTypes.string,
  creditScoreDecline: PropTypes.bool,
  crossSellAppStatus: PropTypes.arrayOf(crossSellAppStatusType),
  disclosurelistAppReady: PropTypes.bool,
  disclosurelistClosingComplete: PropTypes.bool,
  disclosurelistClosingReady: PropTypes.bool,
  disclosurelistSummaryComplete: PropTypes.bool,
  disclosurelistSummaryReady: PropTypes.bool,
  disclosurelistUuid: PropTypes.string,
  dtiDecline: PropTypes.bool,
  employmentVerificationNeeded: PropTypes.bool,
  giactAccountStatus: giactAccountStatusType,
  krangStatus: PropTypes.string,
  manualPaystubUpload: PropTypes.bool,
  manualPaystubTasksCompelte: PropTypes.bool,
  primaryParticipantAcceptsComplete: PropTypes.bool,
  primaryParticipantAcceptsReady: PropTypes.bool,
  showDelinquencyReview: PropTypes.bool,
  softCreditFrozen: PropTypes.bool,
  softCreditFrozenWithPin: PropTypes.bool,
  softCreditLocked: PropTypes.bool,
  softCreditNoMatch: PropTypes.bool,
  softCreditNoMatchWithSsn: PropTypes.bool,
  uwDecision: PropTypes.string,
  uwSubDecision: PropTypes.string,
  bypassKycReview: PropTypes.bool,
});

export const personalLoanType = PropTypes.shape({
  appStatus: PropTypes.string,
  autopayAccount: autopayAccountType,
  consentsList: PropTypes.arrayOf(consentType),
  currentLivingArrangement: PropTypes.string,
  desiredLoanAmount: PropTypes.number,
  disburseAccount: disburseAccountType,
  documents: PropTypes.arrayOf(documentType),
  employmentVerificationNeeded: PropTypes.bool,
  identityUuid: PropTypes.string,
  income: incomeType,
  incomeSources: PropTypes.arrayOf(incomeSourceType),
  loanNumber: PropTypes.string,
  manualPaystubs: PropTypes.arrayOf(manualPaystub),
  payType: PropTypes.string,
  reason: PropTypes.string,
  selectedOffer: selectedOfferType,
  status: statusType,
  uuid: PropTypes.string,
});
